import { LazyAtlassianNavigation } from '@atlassian/jira-atlassian-navigation/src/async.tsx';
import { fg } from '@atlassian/jira-feature-gating';
import { LazyHorizontalNavQueue } from '@atlassian/jira-horizontal-nav-queue/src/async-for-paint.tsx';
import { AsyncHorizontalNavQueue } from '@atlassian/jira-horizontal-nav-queue/src/async.tsx';
import { embeddedIssuePreloadLayoutBuilder } from '@atlassian/jira-issue-preload-layout/src/index.tsx';
import { LazyIssueApp } from '@atlassian/jira-lazy-issue-app/src/LazyIssueApp.tsx';
import { MENU_ID } from '@atlassian/jira-navigation-apps-common/src/constants.tsx';
import { horizontalNavQueueResource } from '@atlassian/jira-navigation-apps-resources/src/controllers/horizontal-navigation/horizontal-nav-queue/index.tsx';
import { LazyForPaintServicedeskSidebar } from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async-for-paint.tsx';
import AsyncSidebarServicedesk from '@atlassian/jira-navigation-apps-sidebar-servicedesk/src/async.tsx';
import { createEntry } from '@atlassian/jira-route-entry/src/createEntry.tsx';
import { composeLayouts } from '@atlassian/jira-route-layout/src/GlobalComponent.tsx';
import { newIssueViewLockInStatusResource } from '@atlassian/jira-router-resources-classic-projects/src/services/new-issue-view-lock-in-status/index.tsx';
import { getConsolidationStateResource } from '@atlassian/jira-router-resources-eoc-tenant-info/src/services/index.tsx';
import {
	getInsightResources,
	getIssueListSsrResource,
	getIssueViewResources,
	getKnowledgeBaseResources,
	getQueuesResources,
	getTriageButtonPermissionResource,
} from '@atlassian/jira-router-resources-service-desk-common/src/index.tsx';
import { queuesJqlBuilderHydrationQueryRelayResource } from '@atlassian/jira-router-resources-service-desk-queues/src/services/queues-jql-builder-hydration-query-relay-resource/index.tsx';
import { resourceWithCondition2 } from '@atlassian/jira-router-resources-utils/src/utils/resource-with-condition/index.tsx';
import { customPracticeQueueRoute } from '@atlassian/jira-router-routes-servicedesk-queue-routes/src/customPracticeQueueRoute.tsx';
import { serviceProjectLayout } from '@atlassian/jira-service-project-layout/src/index.tsx';
import { getAIContextPanelResources } from '@atlassian/jira-servicedesk-ai-context-panel-resources/src/services/index.tsx';
import { getDraftReplyPillsResource } from '@atlassian/jira-servicedesk-draft-reply-resources/src/index.tsx';
import { AsyncBulkActionToolbarLazy } from '@atlassian/jira-servicedesk-bulk-actions-toolbar/src/async.tsx';
import {
	CustomQueueRouteComponent,
	LazyServicedeskQueuesAgentAndIssueView,
} from './ui/CustomQueueRouteComponent.tsx';
import { QueueLoadingSkeleton } from './ui/queue/index.tsx';

export const customPracticeQueueRouteEntry = createEntry(customPracticeQueueRoute, () => ({
	group: 'servicedesk',

	// It is important to keep this component consistent across the two routes so
	// that React doesn't unmount it when switching between the routes and the
	// full state is kept so that scroll position and loaded data is kept when
	// going back from issue details to the queues page.
	component: CustomQueueRouteComponent,
	isHydrateRootEnabled: false,

	layout: composeLayouts(
		serviceProjectLayout,
		embeddedIssuePreloadLayoutBuilder([
			{
				params: [
					{
						key: 'issueKey',
					},
				],
			},
		]),
	),

	skeleton: fg('jsm_views_inside_queues_-_main_flag') ? QueueLoadingSkeleton : undefined,

	navigation: {
		menuId: MENU_ID.PROJECTS,
		sidebar: AsyncSidebarServicedesk,

		horizontal: fg('jsm_views_inside_queues_-_main_flag') ? AsyncHorizontalNavQueue : undefined,
	},

	resources: [
		...getQueuesResources(),
		...getKnowledgeBaseResources(),
		...getInsightResources(),
		...getIssueListSsrResource(),
		...getTriageButtonPermissionResource(),
		newIssueViewLockInStatusResource,
		getConsolidationStateResource(),
		...getAIContextPanelResources(),
		...getDraftReplyPillsResource(),
		resourceWithCondition2(
			() => fg('jsm_views_inside_queues_-_main_flag'),
			horizontalNavQueueResource,
		),
		...getIssueViewResources(),
		resourceWithCondition2(
			() => fg('queues_jql_builder_hydration_query'),
			queuesJqlBuilderHydrationQueryRelayResource,
		),
	],

	afterPaint: fg('jsm_remove_queue_bulk_action_bar_from_preloading')
		? [LazyIssueApp, LazyHorizontalNavQueue]
		: [LazyIssueApp, AsyncBulkActionToolbarLazy, LazyHorizontalNavQueue],

	forPaint: [
		LazyAtlassianNavigation,
		LazyServicedeskQueuesAgentAndIssueView,
		LazyForPaintServicedeskSidebar,
	],

	supportsPreviewPanel: true,

	bifrost: {
		bifrostGroup: 'jira-service-management',
		bundling: {
			packageName:
				'@atlassian/jira-router-routes-servicedesk-queue-entries/src/customPracticeQueueRouteEntry.tsx',
			whichExportToUse: 'customPracticeQueueRouteEntry',
		},
		manifestName: 'jira-spa-jira-service-management.json',
		enabled: true,
	},
}));
